const GET_CONTACT = 'GET_CONTACT';
export default {
  GET_CONTACT,
};
